import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

/* CONTEXTS */
import { CartProvider } from "./context/CartContext";
import { LabCartProvider } from "./context/LabCartContext";
import { PackageCartProvider } from "./context/PackageCartContext";
import { UserProvider } from "./context/UserContext";

/* 🔥 NEW CONTEXT */
import { PopupLockProvider } from "./context/PopupLockContext";

/* REDUX */
import { Provider } from "react-redux";
import { store } from "./Redux/Store";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <UserProvider>
          <CartProvider>
            <LabCartProvider>
              <PackageCartProvider>
                <PopupLockProvider>
                  <App />
                </PopupLockProvider>
              </PackageCartProvider>
            </LabCartProvider>
          </CartProvider>
        </UserProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);